import * as React from 'react';
import { getStyles } from './styles';
import { clsx as cx } from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Компонент для рендера полноэкранного модального окна
 *
 * @export
 * @class ModalFullscreen
 * @extends {React.Component<IModalFullscreenViewProps>}
 */
export function ModalFullscreenView(props) {
  var children = props.children,
    theme = props.theme,
    zIndex = props.zIndex,
    print = props.print;
  var styles = getStyles(theme);
  return /*#__PURE__*/_jsx("div", {
    className: cx(styles['fullscreen'], !print && styles['no-print']),
    style: {
      zIndex: zIndex
    },
    "aria-modal": "true",
    role: "dialog",
    children: children
  });
}
ModalFullscreenView.defaultProps = {
  theme: 'white',
  print: true
};